export const MAX_VIDEO_RECORD_SECONDS_DURATION = 30;
